<script>
import animation from '../components/animate.vue';
import logo from '../components/logo.vue';
import menuToggle from '../components/menu-toggle.vue';

export default {
    components: {
        animation,
        logo,
        'menu-toggle': menuToggle
    },

    mounted() {
        this.$root.headerHeight = this.$refs.header.clientHeight;
    }
};
</script>
